import { Navigate, useLocation } from 'react-router-dom';
import { useLicenseStatus } from '../../hooks/useLicenseStatus';
import toast from 'react-hot-toast';

interface LicenseRouteGuardProps {
  children: React.ReactNode;
  allowLicensePage?: boolean;
}

export default function LicenseRouteGuard({ children, allowLicensePage = false }: LicenseRouteGuardProps) {
  const location = useLocation();
  const { canAccess, isLoading, isPending, isRejected, isExpired, hasNoLicense } = useLicenseStatus();

  const isLicensePage = location.pathname === '/settings/license';
  if (allowLicensePage || isLicensePage) {
    return <>{children}</>;
  }

  if (canAccess || isLoading) {
    return <>{children}</>;
  }

  // عرض تنبيه قوي حسب حالة الترخيص
  let alertMessage = '';
  if (isRejected) {
    alertMessage = 'الترخيص مرفوض! لا يمكن الدخول إلا إلى صفحة الترخيص.';
  } else if (isExpired) {
    alertMessage = 'الترخيص منتهي! لا يمكن الدخول إلا إلى صفحة الترخيص.';
  } else if (hasNoLicense) {
    alertMessage = 'لا يوجد ترخيص نشط! يرجى إضافة ترخيص.';
  } else if (isPending) {
    alertMessage = 'الترخيص قيد المراجعة! لا يمكن الدخول حتى يتم الموافقة عليه.';
  } else {
    alertMessage = 'الترخيص غير صالح! لا يمكن الدخول إلا إلى صفحة الترخيص.';
  }

  // عرض التنبيه
  if (alertMessage) {
    toast.error(alertMessage, {
      id: 'license-guard-alert',
      duration: 8000,
      icon: '⛔',
      style: {
        background: '#7f1d1d',
        color: '#fef2f2',
        border: '2px solid #dc2626',
        fontSize: '15px',
        fontWeight: 'bold'
      }
    });
  }

  // إعادة التوجيه إلى صفحة الترخيص
  return <Navigate to="/settings/license" replace />;
}


